import * as React from 'react';
import Button from '@material-ui/core/Button';
import UpgradeIcon from '@mui/icons-material/Upgrade';

function UpdateToPremium({profile} :any) {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p>Upgrade to a premium plan, unlock all features.</p>
       <Button
        href="/pricing"
        size="small"
        variant="outlined"
        startIcon={<UpgradeIcon />}
      >
        upgrade to premium
      </Button>
      </p>
    </div>
  );
}

export default UpdateToPremium;
